<loading [isLoading]="loadingCanView" [success]="true"></loading>

@if (!loadingCanView) {
    @if (canView) {
        <div class="flex flex-col gap-4 text-sm">
            <div class="flex flex-col sm:flex-row gap-4">
                <!-- View Set -->
                <admin-magic-view-set></admin-magic-view-set>
                <!-- Add Set -->
                <admin-magic-add-set></admin-magic-add-set>
                <!-- Space Filler -->
                <div class="grow"></div>
            </div>
        </div>
    } @else {
        <admin-unauthorized></admin-unauthorized>
    }
}